import { render } from "./px-table-header.vue?vue&type=template&id=1693bdee&scoped=true&ts=true"
import script from "./px-table-header.vue?vue&type=script&lang=ts"
export * from "./px-table-header.vue?vue&type=script&lang=ts"

import "./px-table-header.vue?vue&type=style&index=0&id=1693bdee&lang=scss&scoped=true"
import "./px-table-header.vue?vue&type=style&index=1&id=1693bdee&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1693bdee"]])

export default __exports__